module.exports = __webpack_public_path__ + "static/img/02.197af6f4.png";